import * as React from 'react';

import { Link } from 'react-router-dom';

import { PMLogoIcon } from '@icons';

import blitzLogo from '@assets/images/logos/blitz_logo.webp';
import com2Logo from '@assets/images/logos/com2_logo.png';
import johnnyLogo from '@assets/images/logos/johnny_logo.webp';
import nomadLogo from '@assets/images/logos/nomad_logo.webp';
import sk2Logo from '@assets/images/logos/sk2_logo.webp';

export const useFakeHeaderLogo = (brand?: string) => {
	switch (brand) {
		case 'pm':
			return (
				<Link to={'https://parimatch.kz/pm-pass'} target='_blank'>
					<PMLogoIcon />
				</Link>
			);
		case 'nomad':
			return (
				<Link to={'https://nomadcasino.com/'} target='_blank'>
					<img src={nomadLogo} alt={brand + '-logo'} />
				</Link>
			);
		case 'ngu3':
			return (
				<Link to={'https://24johnny.com/'} target='_blank'>
					<img src={johnnyLogo} alt={'johnny-logo'} />
				</Link>
			);
		case 'rockets':
			return (
				<Link to={'https://parimatch.kz/pm-pass'} target='_blank'>
					<PMLogoIcon />
				</Link>
			);
		case 'com2':
			return (
				<Link to={'https://viphouse-bet.com/'} target='_blank'>
					<img src={com2Logo} alt={'vippass-logo'} />
				</Link>
			);
		case 'blitz':
			return (
				<Link to={'/'}>
					<img src={blitzLogo} alt={'blitz-logo'} />
				</Link>
			);
		case 'sk2':
			return (
				<Link to={'/'}>
					<img src={sk2Logo} alt={'sk2-logo'} />
				</Link>
			);
		default:
			return (
				<Link to={'https://parimatch.kz/pm-pass'} target='_blank'>
					<PMLogoIcon />
				</Link>
			);
	}
};
